/** Eigen backend: alleen CMS-content, instellingen en betaalrecords. */
const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ADMIN_TOKEN_KEY = "beheer_token";

export function adminToken() {
  try {
    return window.localStorage.getItem(ADMIN_TOKEN_KEY);
  } catch (e) {
    return null;
  }
}

export async function cmsCall(method, path, body, { admin = false } = {}) {
  const res = await fetch(`${BASE}${path}`, {
    method,
    headers: {
      "Content-Type": "application/json",
      ...(admin && adminToken() ? { Authorization: `Bearer ${adminToken()}` } : {}),
    },
    body: body ? JSON.stringify(body) : undefined,
  });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    const err = new Error(data.detail || res.statusText);
    err.status = res.status;
    throw err;
  }
  return res.status === 204 ? null : res.json();
}

/** Vertaal Nederlandse CMS-teksten naar en/de/fr via de eigen backend (AI). */
export async function vertaalTeksten(items, talen = ["en", "de", "fr"]) {
  const res = await cmsCall("POST", "/beheer/vertaal", { items, talen }, { admin: true });
  return res.vertalingen || {};
}

/** Vertaald veld uit CMS-content: {nl,en,de,fr} met terugval op nl. */
export function cmsText(field, lang) {
  if (!field) return "";
  if (typeof field === "string") return field;
  const v = field[lang];
  if (typeof v === "string" && v.trim() !== "") return v;
  return field.nl || "";
}

/** Relatieve /api/media-URL's absoluut maken voor preview én productie. */
export function mediaUrl(url) {
  if (!url) return "";
  if (/^https?:\/\//i.test(url) || url.startsWith("data:")) return url;
  if (url.startsWith("/api/media/")) return `${process.env.REACT_APP_BACKEND_URL}${url}`;
  return url;
}
